import _mock from "../_mock";

const status = ['avalible', 'busy']
export const _pendingBranchesList = [...Array(24)].map((_, index) => ({
  name: 'Branch',
  status: status[Math.trunc(Math.random() * status.length)],
  location: 'St Georgica Terrace, Perth',
  total_order: _mock.number.age(index),
  completed_order: _mock.number.age(index),
  reviews: _mock.number.age(index),
}));

export const _BranchesDailyPerformanceList = [...Array(24)].map((_, index) => ({
  name: truncate(_mock.company(index), 15),
  status: "active",
  total: _mock.number.age(index) * 2,
  completed: _mock.number.age(index),
  messages: _mock.number.age(index),
}));

export const _BranchesMonthlyPerformanceList = [...Array(24)].map(
  (_, index) => ({
    name: truncate(_mock.company(index), 15),
    location: truncate(_mock.address.fullAddress(index), 20),
    total: _mock.number.age(index) * 5,
    completed: _mock.number.age(index) * 4,
    cancelled: _mock.number.age(index),
    revenue: _mock.number.age(index),
    review: _mock.number.age(index) * 3,
  })
);

export const _BranchesPerformanceList = [...Array(24)].map((_, index) => ({
  name: truncate(_mock.company(index), 15),
  invoice_id: _mock.id(index),
  withdrawal_and_deposit_date: "20.Jun.2022",
  total: _mock.number.age(index) * 5,
  due_date: "20.Jun.2022",
  status: "paid",
  invoice_type: "type",
  legate: "legate Name",
}));

//-----------------------------------------------

// truncate function to trim string to specific length
function truncate(string, n) {
  return string?.length > n ? string.substr(0, n) + "..." : string;
}
